import { Vec3 } from '../math/Vec3';
import type { SimulationSnapshot } from './types';

/** Structured cloning drops class prototypes. Restore every vector at the boundary. */
export function hydrateSnapshot(snapshot: SimulationSnapshot): SimulationSnapshot {
  return {
    ...snapshot,
    config: { ...snapshot.config, cubeSize: Vec3.from(snapshot.config.cubeSize) },
    meshes: snapshot.meshes.map(mesh => ({ ...mesh, origin: Vec3.from(mesh.origin), normal: Vec3.from(mesh.normal),
      segments: mesh.segments.map(segment => ({ ...segment, start: Vec3.from(segment.start), end: Vec3.from(segment.end) })),
    })),
    emitters: snapshot.emitters.map(emitter => ({ ...emitter, position: Vec3.from(emitter.position) })),
    voxels: snapshot.voxels.map(voxel => ({ ...voxel, position: Vec3.from(voxel.position) })),
    rays: snapshot.rays.map(ray => ({ ...ray, origin: Vec3.from(ray.origin), direction: Vec3.from(ray.direction), target: Vec3.from(ray.target),
      firstIntersection: ray.firstIntersection ? { ...ray.firstIntersection, position: Vec3.from(ray.firstIntersection.position) } : null,
    })),
  };
}
